export default __webpack_public_path__ + "static/media/css.3a3c9873.png";